export default {
  Module: 'Module',
  Function: 'Function',
  ExecutionObject: 'execution object',
  OperatTime: 'Operating time',
  ChangeUser: 'modified person',
  ModifyRole: 'Modify role',
  SearchPlaceholder: 'Search for user account/operation description',
  Result: 'Result',
  OperationDescription: 'Operation Description',
}
